<div class="text-[#f6f6f6] text-center mainContainer relative select-none cursor-pointer">
  <h3 routerLinkActive="active" routerLink="/home" class="menu p-3 md:p-2">Home</h3>
  <h3 routerLinkActive="active" routerLink="/art" class="menu p-3 md:p-2">Art</h3>
  <h3 routerLinkActive="active" routerLink="/dev" class="menu p-3 md:p-2">Dev</h3>
  <h3 routerLinkActive="active" routerLink="/about-me" class="menu p-3 md:p-2">About-Me</h3>
  <div class="absolute top-0 w-full h-full bg-bitterRed -z-20 backColor"></div>
</div>
